import React from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import {  ButtonDouble } from "../../../../widget/common/form/Button";
import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";

const DeactivateAccountButtons = (props: { type?: number | undefined }) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  return (
    <div style={{ width: type === 3 ? 420 : `100%` }}>
      <ButtonDouble
        title1="cancel"
        title2="continue"
        handleClick1={() => navigate(-1)}
        handleClick2={() =>
          navigate(appRoutes.routeNameSettingsDeactivateAccountReason)
        }
      />
    </div>
  );
};

export default DeactivateAccountButtons;
